var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('info-row',{attrs:{"titreSeul":true,"intitule":_vm.intitule,"numero":_vm.numero}}),_c('info-row',{attrs:{"valeurSeule":true}},[_vm._v(" "+_vm._s(_vm.valeur)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }